import { render, staticRenderFns } from "./monthlyStatistics.vue?vue&type=template&id=22e56511&scoped=true&"
import script from "./monthlyStatistics.vue?vue&type=script&lang=js&"
export * from "./monthlyStatistics.vue?vue&type=script&lang=js&"
import style0 from "./monthlyStatistics.vue?vue&type=style&index=0&id=22e56511&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e56511",
  null
  
)

export default component.exports